<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Glass';
                }
            },
            frameCombination: {
                required: true
            },
            sideVariant: {
                required: false,
                default() {
                    return 0;
                }
            },
            securedByDesign: {
                required: true,
            },
            slab: {
              required: true,
            },
            panelCategory: {
                required: false,
                default(){
                    return 0;
                }
            },
            typeRange: {
              required: true,
            },
            help_text: {
                default(){
                    return 'Laminated glass holds together when shattered. Toughened Glass breaks into small blunt pieces when shattered.';
                }
            },
            show_help_text: {
                default(){
                    return false;
                }
            },
        },
        computed: {
            url(){
              return '/api/options/' + this.fabricator + '/side-glass?frame_combination=' + this.frameCombination + '&secured_by_design=' + this.securedByDesign + '&side_variant=' + this.sideVariant + '&slab=' + this.slab + '&type_range=' + this.typeRange + '&panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_' + this.frameCombination + '_' + this.securedByDesign + '_' + this.sideVariant + '_' + this.slab + '_' + this.typeRange + '_' + this.panelCategory;
            },
            passed_filter(){
                return this.variable_ready(this.frameCombination, this.securedByDesign, this.sideVariant, this.slab, this.typeRange, this.panelCategory);
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
